export const NOT_AUTHORIZED = 401;
